<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	export let pageTitle = null;
	export let lastVisitedPage = null;
	export let disabled = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		//  Get the user Agent
		$model.UserAgent = navigator.userAgent;
		$model.referrer = document.referrer;
		$model.RegistrationSegmentId = null;
	}

	const handleSubmit = (e) => {
		buttons.blockNext();

		e.preventDefault();
		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey3, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = "/api/gverify";
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						await registerFormStart();

						buttons.next();
						buttons.unblock();
						return true;
					}

					grecaptcha.render(document.getElementById("g-recaptcha"), {
						sitekey: projectSettings.gSiteKey2,
						callback: reCaptchaV2
					});
				}

				return false;
			});
		});
	};

	const reCaptchaV2 = async (token) => {
		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json"
			},
			body: JSON.stringify({ token: token })
		};

		let url = "/api/gverifyv2";
		let response = await fetch(`${url}`, options);
		let data = await response.json();

		if (data.status) {
			await registerFormStart();

			buttons.next();
			buttons.unblock();
		}
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h1 class="text-center">Express my interest in the {@html projectSettings.classActionName}</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					To express your interest in the {@html projectSettings.classActionName}, you must:
				</p>
				<ul>
					<li>Have been exposed to the toxic herbicide Paraquat; <b>and</b></li>
					<li>
						Have since been diagnosed with Parkinson's disease or have experienced Parkinson's symptoms; <b
							>or</b>
					</li>
					<li>
						Be registering on behalf of a family member who meets the criteria above and has since passed
						away.
					</li>
				</ul>
				<p>
					To express your interest on a confidential, no-cost, no-obligation basis, please click the button
					below and fill out the form.
				</p>
			</FormColumn>
		</FormRow>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<p class="mb-3">
						Do you agree to provide us with personal information which will be kept confidential under the
						Shine Lawyers
						<a href="https://www.shine.com.au/privacy-policy" title="Privacy Policy" target="_blank"
							>Privacy Policy</a
						>?
					</p>
					<Checkbox
						required="true"
						{disabled}
						bind:checked={$model.privacyPolicyConfirmed}
						label="I agree to the privacy policy"
						id="privacy"></Checkbox>
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn class="text-center" cols="12">
				<NavigationButtons
					showPrevious={false}
					bind:buttons
					nextPageLabel="REGISTER MY INTEREST"
					disableNext={!$model.privacyPolicyConfirmed}></NavigationButtons>
			</FormColumn>
			<FormColumn cols="12">
				<div class="recaptcha">
					<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
				</div>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					If you require support completing your registration, please contact Shine Lawyers on
					<ClassActionPhoneNumber></ClassActionPhoneNumber> or email
					<ClassActionEmailAddress></ClassActionEmailAddress>.
				</p>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}

	.unbold {
		font-weight: normal;
	}

	ul {
		margin-left: 20px;
	}

	li {
		padding-left: 20px;
	}
</style>
